import React, { Component } from "react";
import { Modal } from "antd";
import "./HomeTourModal.css";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  ExploreStep1,
  ExploreStep2,
  ExploreStep3,
  ExploreStep4
} from "./ExploreSteps";
import { Button } from "antd";
import { editTourExplore } from "../../../actions/TourAction";

export class HomeTourModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      isTourOpen: false,
      listStep: []
    };
  }

  componentDidMount() {
    const { tourExplore } = this.props;
    var stepsValuesTourExplore = [];
    if (tourExplore && tourExplore.length !== 0) {
      tourExplore.forEach(r => {
        switch (r.title) {
          case "tour_title_step_21":
            r.content = <ExploreStep1 />;
            break;
          case "tour_title_step_22":
            r.content = <ExploreStep2 />;
            break;
          case "tour_title_step_23":
            r.content = <ExploreStep3 />;
            break;
          case "tour_title_step_24":
            r.content = <ExploreStep4 />;
            break;
          default:
            break;
        }
        stepsValuesTourExplore.push({ ...r });
      });
    }
    if (stepsValuesTourExplore.length === 0) return;
    this.setState({
      isTourOpen: true,
      step: 0,
      listStep: stepsValuesTourExplore
    });
  }

  handleSeenSteps = () => {
    const { user, tourExplore } = this.props;
    const { step } = this.state;
    const stepsView = [];
    if (tourExplore && tourExplore.length) {
      for (let i = 0; i <= step; i++) {
        stepsView.push(tourExplore[i].number);
      }
    }
    this.props.editTourExplore(user._id, stepsView);
    this.setState({ isTourOpen: false });
  };

  render() {
    const { closable = true, newColor } = this.props;

    const { step, isTourOpen, listStep } = this.state;

    return (
      <React.Fragment>
        <Modal
          visible={isTourOpen}
          onCancel={this.handleSeenSteps}
          closable={closable}
          width={"80%"}
          footer={null}
          centered
          className="e-t-modalstyle"
        >
          {listStep && listStep.length !== 0 && (
            <div>
              {listStep.map((s, ind) => (
                <div key={ind}>{ind === step && <div> {s.content} </div>}</div>
              ))}
            </div>
          )}
          {/* {
                        step === 0 ? <ExploreStep1/> :
                        step === 1 ? <ExploreStep2/> :
                        step === 2 ? <ExploreStep3/> :
                        step === 3 ? <ExploreStep4/> : <div></div>
                    } */}
          <div className="e-t-outbutton">
            {step > 0 && (
              <Button
                size={"large"}
                type={"primary"}
                block
                className="e-t-outbutton-item"
                style={{
                  backgroundColor: "white",
                  borderColor: newColor,
                  color: newColor
                }}
                onClick={() => {
                  this.setState({
                    step: step - 1
                  });
                }}
              >
                Anterior
              </Button>
            )}
            <Button
              size={"large"}
              type={"primary"}
              block
              className="e-t-outbutton-item"
              style={{
                backgroundColor: newColor
              }}
              onClick={() => {
                if (step === listStep.length - 1) {
                  this.handleSeenSteps();
                  return;
                }
                this.setState({
                  step: step + 1
                });
              }}
            >
              {step < listStep.length - 1 ? "Siguiente" : "Entendido"}
            </Button>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    tourExplore: state.tours.tourExplore
  };
};

const mapDispatchToProps = {
  editTourExplore
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeTourModal))
);
